import ButtonLink from '@/components/links/ButtonLink';
import useLocale from 'next-translate/useTranslation';
import Image from 'next/image';

export default function Certifications() {
  const { t } = useLocale('b2b');

  return (
    <div className='bg-white py-24 dark:bg-slate-900 sm:py-32'>
      <div className='mx-auto max-w-7xl px-6 lg:px-8'>
        <div className='grid grid-cols-1 items-center gap-x-8 gap-y-8 lg:grid-cols-2'>
          <div className='mx-auto w-full max-w-xl lg:mx-0'>
            <h2 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-white'>
              {t('Our Certifications and Compliances')}
            </h2>
            <h2 className='mt-6 text-xl font-bold tracking-tight text-gray-900 dark:text-white'>
              ISO 27001
            </h2>
            <p className='mt-6 text-lg leading-8 text-gray-600 dark:text-gray-300'>
              {t('A globally recognized standard for establishing, implementing, maintaining, and continually improving an information security management system (ISMS).')}
            </p>
            <h2 className='mt-6 text-xl font-bold tracking-tight text-gray-900 dark:text-white'>
              SOC 2
            </h2>
            <p className='mt-6 text-lg leading-8 text-gray-600 dark:text-gray-300'>
              {t('Developed by the American Institute of CPAs (AICPA), the standard is based on the following Trust Services Criteria: security, availability, processing integrity, confidentiality, and privacy.')}
            </p>
            <h2 className='mt-6 text-xl font-bold tracking-tight text-gray-900 dark:text-white'>
              GDPR
            </h2>
            <p className='mt-6 text-lg leading-8 text-gray-600 dark:text-gray-300'>
              {t('The General Data Protection Regulation, a comprehensive data protection law in the EU, governs how organizations must protect personal data and privacy.')}
            </p>
            <h2 className='mt-6 text-xl font-bold tracking-tight text-gray-900 dark:text-white'>
              HIPAA
            </h2>
            <p className='mt-6 text-lg leading-8 text-gray-600 dark:text-gray-300'>
              {t('The Health Insurance Portability and Accountability Act, a U.S. law that mandates standards for protecting sensitive patient health information.')}
            </p>
            <div className='mt-10 flex items-center gap-x-6'>
              <ButtonLink href='/login?preset=bots' variant='dark'>
                {t('Get started for free')}
              </ButtonLink>
              <span className='hidden text-sm font-semibold leading-6 text-gray-500 sm:block'>
                {t('No credit card required')}
              </span>
            </div>
          </div>
          <div className='mx-auto grid max-w-xl grid-cols-2 items-center gap-y-4 sm:gap-y-14 lg:mx-0 lg:max-w-none lg:pl-8'>
            <Image
              className='max-h-18 object-contain object-left'
              src='/images/iso-27001.png'
              alt='ISO 27001'
              width={200}
              height={200}
            />
            <Image
              className='max-h-18 object-contain object-left'
              src='/images/about-us/SOC.png'
              alt='SOC 2'
              width={200}
              height={200}
            />
            <Image
              className='max-h-18 object-contain object-left'
              src='/images/gdpr.png'
              alt='GDPR'
              width={200}
              height={200}
            />
            <Image
              className='max-h-18 object-contain object-left'
              src='/images/about-us/HIPAA-square-logo 2.png'
              alt='HIPAA'
              width={200}
              height={200}
            />
            {/* <img
              className="max-h-12 w-full object-contain object-left"
              src="https://tailwindui.com/img/logos/transistor-logo-gray-400.svg"
              alt="Transistor"
              width={158}
              height={48}
            />
            <img
              className="max-h-12 w-full object-contain object-left"
              src="https://tailwindui.com/img/logos/statamic-logo-gray-400.svg"
              alt="Statamic"
              width={147}
              height={48}
            /> */}
          </div>
        </div>
      </div>
    </div>
  );
}
